import { useMutation } from '@tanstack/react-query';
import { AssessmentActivityLogsRef } from '../../utils/refs';
import { setDoc } from 'firebase/firestore';
import { captureError } from '../../utils';

export const writeAssessmentActivityLog = async (assessmentID, questionID, type, data) => {
  const docRef = AssessmentActivityLogsRef(assessmentID);

  try {
    let id = new Date().valueOf();
    if (type === 'responseSubmitted') {
      id -= 850;
    }

    await setDoc(
      docRef,
      {
        actions: {
          [`${id}`]: {
            id: questionID,
            action: type,
            timestamp: id,
            // firestore rejects undefined, so only carry a payload when there is one
            ...(data ? { data } : {})
          }
        }
      },
      { merge: true }
    );
  } catch (err) {
    captureError(err, { assessmentID, questionID, type, write: 'activityLog' });
  }

  return { changes: { questionID, type, data } };
};

export default function useUpdateAssessmentActivityLog(assessmentID) {
  const UpdateAssessmentActivityLogMutation = ({ questionID, type, data }) => {
    return writeAssessmentActivityLog(assessmentID, questionID, type, data);
  };

  return useMutation({
    mutationFn: UpdateAssessmentActivityLogMutation,
    onError: (error, variables) => {
      captureError(error, { assessmentID, ...variables, write: 'activityLog' });
    },
    onSuccess: ({ changes }) => {
      console.log('Successfully updated assessment activity log', changes);
    }
  });
}
